var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('selectable-service-resource',{staticClass:"required",attrs:{"label":_vm.$t('Source\'s resource'),"error-messages":_vm.errors['resource']},model:{value:(_vm.resource),callback:function ($$v) {_vm.resource=$$v},expression:"resource"}})}
var staticRenderFns = []

export { render, staticRenderFns }